<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="模板下载"
      :innerHeight="150"
      width="400px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-checkbox-group v-model="checkList">
        <el-checkbox
          v-for="(item, index) in fileList" :key="index"
          :label="item.data"
        >{{item.data.fileName}}</el-checkbox>
      </el-checkbox-group>
    </q-dialog>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
import {debounce} from '@/utils/index'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible'],
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      checkList: []
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
    this.init();
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm:debounce(function(){
      if(!this.checkList.length) {
        this.$message.error('请先选择模板类型');
        return;
      }
      this.checkList.forEach(res=>{
        this.downLoad(res.templatePath, res.fileName)
      })
      this.updateVal();
    },1000),
    init() {
      let reportName = ['excusePlateImport', 'excuseSofaBedImport', 'excuseMattressImport'];

      let func1 = axios.get(`/qu-platform-excel-api/excel/cfg/getTemplate/${reportName[0]}`);
      let func2 = axios.get(`/qu-platform-excel-api/excel/cfg/getTemplate/${reportName[1]}`);
      let func3 = axios.get(`/qu-platform-excel-api/excel/cfg/getTemplate/${reportName[2]}`);
      Promise.all([func1, func2, func3])
      .then(resAll=>{
        this.fileList = resAll;
      })
    },
    downLoad(path, name) {
      let url = path;
      let fileName = name;
      var xhr = new XMLHttpRequest();
      xhr.open("GET",url, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement("a");
            var body = document.querySelector("body");

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    }
  }
}
</script>

<style>

</style>